import React from "react";
import MenuLayouts from "../layouts/menu.layout";
import TarjetasComponent from "../components/nosotros/tarjetas.component";
import ServiciosComponent from "../components/nosotros/servicios.component";
import TestimoniosComponent from "../components/nosotros/testimonios.component";
import TestimonioVideoComponent from "../components/nosotros/testimonio_video.component";
import FooterLayout from "../layouts/footer.layout";
import banner from "../styles/images/banner_superior_nosotros.webp";
/*eslint-disable */
const NosotrosPage: React.FC = () => {
  return (
    <>
      <MenuLayouts />
      <div className="page-title-area" style={{backgroundImage: `URL(${banner})`, backgroundSize: "cover", backgroundPosition: "center"}}>
        <div className="container">
          <div className="page-title-content">
            <h1 style={{color: "#fff"}}>Nosotros</h1>
          </div>
        </div>
      </div>
      <TarjetasComponent />
      <ServiciosComponent />
      <TestimoniosComponent />
      <TestimonioVideoComponent />
      <FooterLayout />
    </>
  );
};

export default NosotrosPage;
